<div class="text-16">
	<span [dcrHTMLKey]="coverageDcrKey" data-cy="esg-coverage-text">Not all funds are covered, so you should consider portfolio coverage when evaluating ESG.</span
	><span data-cy="esg-coverage-data"> {{ coverageText }}</span>
</div>
